import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/cargoOwnerDictionary";
const listQuery = { orderBy: ["lastUsedAt desc"] };

const index = ({ preparedFilter, counterpartyId, ...params }: OdataFilters & { counterpartyId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery }).substr(1);
    return request(
        `${resource}/getCounterpartyPoints?counterpartyId=${counterpartyId}&${query}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const getListExcel = ({ preparedFilter, counterpartyId, ...params }: OdataFilters & { counterpartyId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(
        `${resource}/getCounterpartyPointsExcel?counterpartyId=${counterpartyId}&${query}`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Адреса контрагентов.xlsx"));
};

const list = ({ counterpartyId, ...params }: OdataFilters & { counterpartyId: number }) =>
    request(
        `${resource}/getCounterpartyPoints?counterpartyId=${counterpartyId}&${containsQuery(params, listQuery).substring(1)}`,
        {
            method: "GET",
        },
    );

const apply = (params: {}) => alertRequest(`${resource}/applyCounterpartyPoint`, body(params));
const getItem = (params: { id: number }) => request(`${resource}/getCounterpartyPoint/${params.id}`, { method: "GET" });
const delItem = (params: {}) => alertRequest(`${resource}/deleteCounterpartyPoint`, body(params));

export { index, apply, getItem, delItem, list, getListExcel };
